document.addEventListener('DOMContentLoaded', () => {
  const menuDrawer = document.querySelector('.menu-drawer');

  // Cerrar el menú si se hace clic fuera
  document.addEventListener('click', (event) => {
    const isClickInside = menuDrawer.contains(event.target);
    const isSummaryClicked = event.target.closest('summary');

    if (!isClickInside && menuDrawer.hasAttribute('open')) {
      menuDrawer.removeAttribute('open'); // Cierra el menú
    }
  });

  // Prevenir cierre si se hace clic dentro del menú
  menuDrawer.querySelector('.menu-drawer__content').addEventListener('click', (event) => {
    event.stopPropagation();
  });
});
